import fp from "lodash/fp";

import { axiosWithAuth, convertDateToISO, TIME_OFFSET_DAY_END } from "helpers";

export const merchantBatchHistoryTabService = {
	getBatchHistoryList,
	getViewTransactionsDetails,
	getCvs,
	getTransactionCvs,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getBatchHistoryList({ page, sortBy, id, filters }) {
	let cloneFilters = fp.cloneDeep(filters);

	const dateFrom = cloneFilters?.datesBatchHistory?.[0];
	const dateTo = cloneFilters?.datesBatchHistory?.[1];

	delete cloneFilters?.datesBatchHistory;

	const body = {
		page,
		pageSize: PAGE_SIZE,
		filterModel: {
			...cloneFilters,
			from: convertDateToISO(dateFrom),
			to: convertDateToISO(dateTo, {
				addTime: TIME_OFFSET_DAY_END,
			}),
		},
		sortType: sortBy?.id || undefined,
		ascending: sortBy?.id ? sortBy?.desc : undefined,
	};
	const options = {
		method: "POST",
		data: body,
		url: `${API_URL}/api/merchants/${id}/batchHistory`,
	};

	return axiosWithAuth(options);
}

function getCvs(merchantId, batchSummaryId) {
	let user = JSON.parse(localStorage.getItem("user") || "");
	const url = `${API_URL}/api/merchants/${merchantId}/batchHistory/${batchSummaryId}/csv?token=${user.access_token}`;
	var link = document.createElement("a");
	link.href = url;
	link.click();
}

function getTransactionCvs(merchantId, transactionId) {
	let user = JSON.parse(localStorage.getItem("user") || "");
	const url = `${API_URL}/api/merchants/${merchantId}/batchHistory/transactions/${transactionId}/csv?token=${user.access_token}`;
	var link = document.createElement("a");
	link.href = url;
	link.click();
}

function getViewTransactionsDetails(merchantId, batchNumber, page) {
	const options = {
		method: "GET",
		params: {
			page: page,
			pageSize: PAGE_SIZE,
		},
		url: `${API_URL}/api/merchants/${merchantId}/batchHistory/${batchNumber}/transactions`,
	};

	return axiosWithAuth(options);
}
